import { PlessViewUtilsSub } from './../../kymw00/pless-view-utils-sub.service';
import { Injectable } from '@angular/core';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';

/** ファイル形式指定 */
export namespace FileAccept {
  export const CSV = '.csv';
  export const TXT = '.txt';
  export const EPS = '.eps';
  export const PNG = '.png';
  export const JPG = '.jpg';
  export const JPEG = '.jpeg';
  export const PDF = '.pdf';
  export const XLSX = '.xlsx';
}

/**
 * ファイルをアップロードして処理を行うサービス
 *
 * @export FileUploadService
 * @class FileUploadService
 */
@Injectable()
export class FileUploadService {
  /**
   * Creates an instance of FileUploadService.
   * @param {dialogService} dialogService ダイアログサービス
   * @memberof FileUploadService
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
  ) { }

  /**
   * ファイルアップロードサービス起動
   * 
   * @param {dialogService} selectedFunction ファイル選択後の処理
   * @param {dialogService} accept ファイル選択時にフィルタリングしてくれる拡張子
   * @param {dialogService} multiple ファイル複数選択可能フラグ true:複数選択可能 false:複数選択不可 デフォルトはfalse
   * @memberof FileUploadService
   */
  // 項番2231 START 障害管理NO.U01024対応
  // public upload(selectedFunction: Function, accept: string, multiple: boolean = false) {
  public upload(selectedFunction: Function, acceptList: string[], multiple = false) {
  // 項番2231 END 障害管理NO.U01024対応
    // 一時的にinput type="file"タグを作成してクリック
    const uploadFileElement = document.createElement('input');
    uploadFileElement.type = 'file';
    uploadFileElement.multiple = multiple;
    // 項番2231 START 障害管理NO.U01024対応
    uploadFileElement.accept = acceptList.join();
    // 項番2231 END 障害管理NO.U01024対応
    uploadFileElement.click();

    uploadFileElement.addEventListener('change', (event: Event) => {
      const selectedFiles = (<any>event.target).files;
      // ファイルサイズチェック
      // ファイル拡張子チェック
      if (this.checkFileSize(selectedFiles)
      // 項番2231 START 障害管理NO.U01024対応
      && this.checkExtension(selectedFiles, acceptList)) {
      // 項番2231 END 障害管理NO.U01024対応
        // ファイル選択後処理
        // ファイルはmultipleの場合を考慮して配列で保持
        selectedFunction(selectedFiles);
      }
    });
  }

  /**
   * アップロードサイズ0バイトの場合チェック
   * ・0バイトの場合：false、アラート表示「（E0219）選択されているファイルは０バイトのファイルです。」
   * ・上記以外の場合：true
   */
  private checkFileSize(selectedFiles: File[]): boolean {
    for (const file of selectedFiles) {
      const size = file.size;
      if (size <= 0) {
        this.dialogService.openAlertGetMessage('E0219');
        return false;
      }
    }
    return true;
  }

  // 項番2231 START 障害管理NO.U01024対応
  /**
   * 標準の拡張子チェック
   * ・拡張子がacceptと一致しない場合：false、アラート表示「（E0220）選択されているファイルの拡張子が不正です。」
   */
  private checkExtension(selectedFiles: File[], acceptList: string[]): boolean {
    if (!PlessViewUtilsSub.isEmptyArray(acceptList)) {
      for (const file of selectedFiles) {
        let acceptOk = false;
        for (const accept of acceptList) {
          const extensionLength = accept.length;
          // 大文字変換することで大文字小文字の差異を無視
          if (file.name.slice(extensionLength * -1).toLowerCase() === accept.toLowerCase()) {
            acceptOk = true;
            break;
          }
        }
        if (!acceptOk) {
          this.dialogService.openAlertGetMessage('E0220');
          return false;
        }
      }
    }
    return true;
  }
  // 項番2231 END 障害管理NO.U01024対応
}
